import { heroData } from '@/mocks/homeData';

export default function Hero() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dramatic%20theatrical%20scene%20with%20warm%20golden%20and%20amber%20light%20beams%20radiating%20from%20center%2C%20dark%20elegant%20background%20with%20soft%20gradients%2C%20artistic%20composition%20with%20subtle%20lens%20flare%2C%20luxurious%20cinematic%20atmosphere%2C%20professional%20stage%20lighting%20effect%2C%20rich%20contrast%20between%20light%20and%20shadow&width=1600&height=1000&seq=hero-bg-001&orientation=landscape"
          alt="51吃瓜网站主视觉背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-24 md:py-32">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full text-center lg:text-left animate-fade-in-up">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium tracking-wide mb-6 whitespace-nowrap">
              {heroData.tag}
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold font-heading text-background-50 leading-tight">
              {heroData.title}
            </h1>

            <p className="mt-4 text-base md:text-lg text-background-50/85 font-medium">
              {heroData.slogan}
            </p>

            <p className="mt-5 text-sm md:text-base text-background-50/70 leading-relaxed max-w-[640px] mx-auto lg:mx-0">
              {heroData.intro}
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-5 justify-center lg:justify-start">
              {heroData.stats.map((stat, i) => (
                <div key={i} className="text-center">
                  <span className="block text-2xl md:text-3xl font-bold text-accent-500 font-heading">
                    {stat.value}
                  </span>
                  <span className="block text-xs text-background-50/60 mt-1">
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href={heroData.primaryCta.href}
                onClick={(e) => { e.preventDefault(); handleClick(heroData.primaryCta.href); }}
                className="px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {heroData.primaryCta.text}
              </a>
              <a
                href={heroData.secondaryCta.href}
                onClick={(e) => { e.preventDefault(); handleClick(heroData.secondaryCta.href); }}
                className="px-7 py-3 rounded-full border border-background-50/40 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {heroData.secondaryCta.text}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] lg:aspect-[5/4]">
              <img
                src="https://readdy.ai/api/search-image?query=dynamic%20entertainment%20collage%20with%20dramatic%20stage%20lighting%2C%20elegant%20theatrical%20composition%2C%20warm%20golden%20and%20amber%20tones%2C%20artistic%20abstract%20representation%20of%20performance%20art%2C%20luxurious%20cinematic%20aesthetic%2C%20professional%20photography%20style%20with%20rich%20textures%20and%20depth&width=1200&height=900&seq=hero-visual-001&orientation=landscape"
                alt="51吃瓜网站特色栏目主视觉展示"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}